import React from 'react';
export function About() {
  return <section id="about" className="py-20 bg-white border-b border-gray-100" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-15">
            Why Swedenmark AI
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto" data-id="element-16"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-start mb-16" data-id="element-17">
          <div className="space-y-8" data-id="element-18">
            <div data-id="element-19">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-20">
                A different kind of AI consulting partner
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-21">
                Most AI consultants hand you a report and walk away. We stay
                until the work is done — embedding with your team, building the
                systems, and measuring the outcomes.
              </p>
            </div>

            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-22">
              We specialize in mid-market companies because that's where AI
              creates the most asymmetric value. You have the complexity of an
              enterprise but the agility to move fast. We help you use that
              advantage to outmaneuver larger competitors.
            </p>

            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-23">
              Our engagements are outcome-focused: defined deliverables, clear
              timelines, and ROI you can measure. Every engagement is structured
              around what drives the best results for your business.
            </p>

            <div className="border-l-4 border-blue-600 pl-6 py-2 bg-gray-50 rounded-r-lg" data-id="element-24">
              <blockquote className="text-xl font-medium text-gray-900 italic" data-id="element-25">
                "Built for companies ready to move from AI curiosity to AI
                advantage."
              </blockquote>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-26">
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" data-id="element-27">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Modern office architecture" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-28" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mt-8" data-id="element-29">
              <img src="https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Strategic planning" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-30" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" data-id="element-31">
              <img src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Data analysis" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-32" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mt-8" data-id="element-33">
              <img src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Team collaboration" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-34" />
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center border-t border-gray-100 pt-8" data-id="element-35">
          <p className="text-gray-400 text-sm italic" data-id="element-36">
            Swedenmark AI takes its name from our founders' Scandinavian roots —
            a nod to the Nordic tradition of building things that are precise,
            durable, and purposeful.
          </p>
        </div>
      </div>
    </section>;
}